module.exports = __webpack_public_path__ + "img/imgbg.0cd31ad5.png";